import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { take } from 'rxjs/operators';
import { OtpService } from 'src/app/service/otp.service';
import { Location } from '@angular/common';

@Component({
  selector: 'app-verify-otp',
  templateUrl: './verify-otp.component.html',
  styleUrls: ['./verify-otp.component.scss']
})
export class VerifyOtpComponent implements OnInit {
  phoneNumber: string | null = null;
  otpCode: string = '';
  isOtpValid: boolean = false;
  isLoading: boolean = false;
  resendTimer: number = 30; // Initial timer value in seconds
  private timerInterval: any;
  isEditFlow: boolean = false;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private otpService: OtpService,
    private snackBar: MatSnackBar,
    private location: Location
  ) { }

  ngOnInit(): void {
    // Get phone number from query params
    this.route.queryParams.pipe(take(1)).subscribe(params => {
      this.phoneNumber = params['phoneNumber'] || null;
      this.isEditFlow = params['isEditFlow'] === 'true';
      if (!this.phoneNumber) {
        // If no phone number, redirect back or show error
        this.snackBar.open('Phone number not provided. Please go back and enter it.', 'Dismiss', { duration: 5000 });
        this.router.navigate(['/add-dealer-phone']);
      }
    });
    this.startResendTimer();
  }

  onOtpInput(): void {
    this.otpCode = this.otpCode.replace(/[^0-9]/g, '').substring(0, 6);
    this.isOtpValid = this.otpCode.length === 6;
  }

  onSubmitOtp(): void {
    if (!this.isOtpValid || !this.phoneNumber) {
      this.snackBar.open('Please enter a valid 6-digit OTP.', 'Dismiss', { duration: 3000 });
      return;
    }

    this.isLoading = true;

    this.otpService.verifyOtp(this.phoneNumber, this.otpCode).subscribe(
      response => {
        this.isLoading = false;
        if (response && response.metaData.responseCode === 'OK') {
          this.router.navigate(['/capture-photo'], { queryParams: { primaryMobile: this.phoneNumber } });
        } else {
          this.snackBar.open(response?.data || 'OTP verification failed. Please try again.', 'Dismiss', { duration: 5000 });
          console.error('API response for OTP verification failed:', response);
        }
      },
      error => {
        this.isLoading = false;
        this.snackBar.open(error.error?.data || 'An error occurred during OTP verification. Please try again later.', 'Dismiss', { duration: 5000 });
      }
    );
  }

  resendOtp(): void {
    if (!this.phoneNumber) {
      this.snackBar.open('Cannot resend OTP without a phone number.', 'Dismiss', { duration: 3000 });
      return;
    }
    this.isLoading = true;
    this.otpService.generateOtp(this.phoneNumber).subscribe(
      response => {
        this.isLoading = false;
        if (response && response.data && response.metaData.responseCode === '200 OK') {
          this.snackBar.open('OTP re-sent successfully!', 'Dismiss', { duration: 3000 });
          this.resendTimer = 30; // Reset timer
          this.startResendTimer();
        } else {
          this.snackBar.open(response?.metaData.responseCode || 'Failed to resend OTP. Please try again.', 'Dismiss', { duration: 5000 });
        }
      },
      error => {
        this.isLoading = false;
        this.snackBar.open(error.error?.metaData.responseCode === 'TOO_MANY_REQUESTS' ? 'Too many requests. Please try again later.' : 'An error occurred while sending OTP. Please try again later.', 'Dismiss', { duration: 5000 });
        console.error('Error resending OTP:', error);
      }
    );
  }

  startResendTimer(): void {
    if (this.timerInterval) {
      clearInterval(this.timerInterval);
    }
    this.timerInterval = setInterval(() => {
      if (this.resendTimer > 0) {
        this.resendTimer--;
      } else {
        clearInterval(this.timerInterval);
      }
    }, 1000);
  }

  goBack(): void {
    this.location.back()
  }

  ngOnDestroy(): void {
    if (this.timerInterval) {
      clearInterval(this.timerInterval);
    }
  }
}